import initCareerCenterSlider from "./init-career-center-slider";
import initCasesSlider from "./init-cases-slider";
import initClassesSlider from "./init-classes-slider";
import initCoachesSlider from "./init-coaches-slider";
import initCoachingReviewsSliders from "./init-coaching-reviews-sliders";
import initCompletingSlider from "./init-completing-slider";
import initExpertsSlider from "./init-experts-slider";
import initLearnDoubleSlider from "./init-learn-double-slider";
import initProgramsSlider from "./init-programs-slider";
import initReviewsSlider from "./init-reviews-slider";
import initTeamSlider from "./init-team-slider";

const sliders = () => {
  initCareerCenterSlider();
  initExpertsSlider();
  initCasesSlider();
  initReviewsSlider();
  initCoachesSlider();
  initProgramsSlider();
  initCompletingSlider();
  initLearnDoubleSlider();
  initClassesSlider();
  initTeamSlider();
  initCoachingReviewsSliders();
}

export default sliders;
